enum ContentLibraryFilterTypes {
  DISCOVER = 'discover',
  LICENSE_REQUESTS = 'license_requests',
  LICENSED = 'licensed',
}

export { ContentLibraryFilterTypes }
